export enum SubscriptionInterval {
  year = 'year',
  month = 'month',
  day = 'day',
}
